import {useState, useEffect} from "react";
import {useMutation, useQueryClient} from "@tanstack/react-query";
import {jwtDecode} from "jwt-decode";
import {
  CommentModalUpdateProps,
  AccessTokenProps,
} from "../../types/ComponentProps";
import CommentsModalStyles from "./CommentsModalStyles.module.css";
import {useCommentDeleteModal} from "../../context/CommentDeleteModalContext";
import deleteComment from "../../api/deleteComment";

const CommentListUpdate = ({
  post,
  onEditClickHandler,
}: CommentModalUpdateProps) => {
  const [dropDown, setDropDown] = useState(false);
  const [jwtDecodeToken, setJwtDecodedToken] = useState<AccessTokenProps>(null);
  const accessToken = localStorage.getItem("accessTokenGC");

  const queryClient = useQueryClient();
  const {openModal} = useCommentDeleteModal();

  useEffect(() => {
    if (accessToken) {
      try {
        setJwtDecodedToken(jwtDecode(accessToken));
      } catch (error) {
        console.error("Invalid token:", error);
      }
    }
  }, [accessToken]);

  const deleteCommentMutation = useMutation({
    mutationFn: () => deleteComment(post?.commentId ?? 0),
    onSuccess: async () => {
      await queryClient.invalidateQueries({queryKey: ["getPostComments"]});
    },
    onError: (error: Error) => {
      console.error("Error deleting comment:", error);
    },
  });

  const onClickHandler = () => {
    setDropDown((prev) => !prev);
  };

  const onEditHandler = () => {
    if (onEditClickHandler) onEditClickHandler();
  };

  const onDeleteHandler = () => {
    openModal(() => deleteCommentMutation.mutateAsync());
  };

  return (
    <div className={CommentsModalStyles.ellipsisSection}>
      {dropDown && (
        <div
          onMouseLeave={() => setDropDown(false)}
          className={CommentsModalStyles.dropDownEllipsisSection}>
          <p onClick={onEditHandler}>Edit</p>
          <p onClick={onDeleteHandler}>Delete</p>
        </div>
      )}
      {jwtDecodeToken?.id !== post?.userId &&
      !jwtDecodeToken?.isAdmin ? null : (
        <span onClick={onClickHandler} className="fa-solid fa-ellipsis"></span>
      )}
    </div>
  );
};

export default CommentListUpdate;
